import React from 'react';
import { ReactComponent as NoReport } from '../../../../assets/images/no-report.svg';
import { ReactComponent as NoProfiles } from '../../../../assets/images/no-profiles.svg';
import classes from './EmptyScreen.module.scss';

type EmptyScreenViewProps = {
  noProfiles: boolean;
};
export const EmptyScreenView = ({ noProfiles }: EmptyScreenViewProps) => {
  return <div className={classes.ImageContainer}>{noProfiles ? <NoProfiles /> : <NoReport />} </div>;
};
